import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import { de } from '@fancyapps/ui/dist/carousel/l10n/de.esm.js';
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";


// initializes slider blocks
const slidersProcess = document.querySelectorAll(".indy-block-process");

if(slidersProcess) {
	for (const slider of slidersProcess) {
		const sliderOptions = {
			l10n: de,
			infinite: false,  // Disable infinite loop to detect the last slide
			Dots: false,
			transition: "slide",
			slidesPerPage: 1,
			center: false,
			Navigation: {
				nextTpl: slider.getAttribute('data-arrow-r'),
				prevTpl: slider.getAttribute('data-arrow-l'),
			},
		};

		const instance = new Carousel(slider, sliderOptions);
		enableKeyboardNavigation(instance, slider);
	}
}

const slidersHero = document.querySelectorAll(".indy-block-hero-slider");

if(slidersHero) {
	for (const slider of slidersHero) {
		const sliderOptions = {
			l10n: de,
			infinite: true,
			Dots: {
				type: "dynamic",
			},
			transition: "slide",
			slidesPerPage: 1,
			center: false,
			Navigation: {
				nextTpl: slider.getAttribute('data-arrow-r'),
				prevTpl: slider.getAttribute('data-arrow-l'),
			},
			Autoplay: {
				timeout: 5000,
			},
		};

		const instance = new Carousel(slider, sliderOptions, { Autoplay });
		enableKeyboardNavigation(instance, slider);
	}
}


const sliderImageText = document.querySelectorAll(".indy-block-image-text-slider > .acf-innerblocks-container");

if (sliderImageText.length) {
	for (const slider of sliderImageText) {
		const parent = slider.parentElement;

		const sliderOptions = {
			l10n: de,
			infinite: true,
			Dots: {
				type: "dynamic",
			},
			transition: "slide",
			slidesPerPage: 1,
			center: false,
			Navigation: {
				nextTpl: parent.getAttribute('data-arrow-r'),
				prevTpl: parent.getAttribute('data-arrow-l'),
			},
		};

		const instance = new Carousel(slider, sliderOptions);
		enableKeyboardNavigation(instance, slider);
	}
}

export const initSlidersBlock = () => {
    const slidersBlock = document.querySelectorAll('.indy-block-slider');
    if (slidersBlock) {
        for (const slider of slidersBlock) {
            // The intro block renders its slider inside ACF's block preview, which React
            // owns and diffs. Initializing the carousel there rewrites that DOM (the
            // slides get moved into an injected viewport), so React fails with a
            // removeChild error as soon as the block re-renders — for example when the
            // thumbnail mode is switched. The template marks that preview as static and
            // already ships the controls as plain markup; the editor check is only a
            // fallback in case the template ever renders the real slider there.
            if (slider.classList.contains('indy-block-slider-static')
                || (slider.classList.contains('indy-block-slider-plain') && isInBlockEditor(slider))) {
                continue;
            }
            // Only initialize if not already initialized
            if (!slider.classList.contains('carousel-initialized')) {
                const sliderOptions = {
                    l10n: de,
                    infinite: false,
                    Dots: true,
                    transition: 'slide',
                    slidesPerPage: 1,
                    center: false,
					adaptiveHeight: true,
                    Navigation: {
                        nextTpl: slider.getAttribute('data-arrow-r'),
                        prevTpl: slider.getAttribute('data-arrow-l'),
                    },
                };
				const instance = new Carousel(slider, sliderOptions);
				enableKeyboardNavigation(instance, slider);
				keepViewportHeightInSync(instance);
                slider.classList.add('carousel-initialized');
            }
        }
    }
};



// Only auto-initialize on the frontend (not in Gutenberg editor)
if (
    typeof window.wp === 'undefined' || // Not in Gutenberg editor
    !document.body.classList.contains('block-editor-page') // Not in block editor
) {
	$(document).ready(function () {
        initSlidersBlock();
    });
}


function isInBlockEditor(element) {
	return !!element.closest('.acf-block-preview')
		|| document.body.classList.contains('block-editor-page');
}


// Carousel writes the viewport height as a fixed pixel value when adaptiveHeight
// is on, but only recalculates it on init, image load and slide change — not when
// the container resizes, so the slider keeps the height it got on page load until
// the page is reloaded. It does detect the resize though: Panzoom watches the
// viewport and its refresh cascades into the carousel's own refresh event, so
// recalculating the height there is enough.
function keepViewportHeightInSync(carouselInstance) {
	carouselInstance.on('refresh', () => {
		carouselInstance.setViewportHeight();
	});
}


//Keyboard Controls

function enableKeyboardNavigation(carouselInstance, sliderElement) {
	// make links untabbable in sliders
	sliderElement.querySelectorAll('a').forEach((slideLink) => {
		slideLink.tabIndex = -1;
	});
	// make current slide link tabbable
	carouselInstance.on("change", (instance) => {
		const prevSlideLink = instance.slides.at(instance.page - 1).el.querySelector('a');
		const nextSlideLink = instance.slides.at(instance.page).el.querySelector('a');
		if(prevSlideLink) {
			prevSlideLink.tabIndex = -1;
		}
		if(nextSlideLink) {
			nextSlideLink.tabIndex = 0;
		}
	});

	let isHovered = false;

	sliderElement.addEventListener("mouseenter", () => {
		isHovered = true;
	});

	sliderElement.addEventListener("mouseleave", () => {
		isHovered = false;
	});

	document.addEventListener("keydown", (e) => {
		if (!isHovered) return;

		// Fokus ignorieren, wenn man in einem Eingabefeld ist
		if (['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName)) return;

		if (e.key === "ArrowLeft") {
			carouselInstance.slidePrev();
		} else if (e.key === "ArrowRight") {
			carouselInstance.slideNext();
		}
	});
}
